export default __webpack_public_path__ + "static/media/arrow-icon-green.c2af0404.svg";